export const materialType = [
  { value: 'FR4', text: 'FR4 Tg135' },
  { value: 'FR4TG175', text: 'FR4 Tg175' },
];

export const finishPlating = [
  { value: 'Leaded Solder', text: 'Leaded Solder' },
  { value: 'Lead Free Solder', text: 'Lead Free Solder' },
  { value: 'ENIG', text: 'ENIG' },
  { value: 'OSP', text: 'OSP' },
  { value: 'Carbon Ink', text: 'Carbon Ink' },
  { value: 'Immersion Silver', text: 'Immersion Silver' },
  { value: 'Immersion Tin', text: 'Immersion Tin' },
  { value: 'Peelable Mask', text: 'Peelable Mask' },
];

export const cooperInner = [
  { value: '0.5 oz', text: '0.5 oz' },
  { value: '1 oz', text: '1 oz' },
  { value: '2 oz', text: '2 oz' },
  { value: '3 oz', text: '3 oz' },
];

export const cooperOuter = [
  { value: '1 oz', text: '1 oz' },
  { value: '2 oz', text: '2 oz' },
  { value: '3 oz', text: '3 oz' },
];